import { render, staticRenderFns } from "./SliderBar.vue?vue&type=template&id=8713ce70&scoped=true"
import script from "./SliderBar.vue?vue&type=script&lang=js"
export * from "./SliderBar.vue?vue&type=script&lang=js"
import style0 from "./SliderBar.vue?vue&type=style&index=0&id=8713ce70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8713ce70",
  null
  
)

export default component.exports